import { useSocialCoachSession } from "./useSocialCoachSession";

// The server decides, using the same rules it enforces on /impersonations: admins
// always; coaches and assistants only with ALLOW_IMPERSONATION, and assistants also
// need IMPERSONATE_PLAYERS write access. While impersonating, it reflects the actor.
export const useCanImpersonate = () => {
  const { session } = useSocialCoachSession();
  return session?.canImpersonate === true;
};
